import noUiSlider from 'nouislider';
import ApplicationController from "./application_controller";

export default class extends ApplicationController{
  static targets = ["slider", "minPrice", "maxPrice"];

  connect() {
    const params = new URLSearchParams(window.location.search);
    
    let min = parseInt(params.get('min_price'), 10);
    let max = parseInt(params.get('max_price'), 10);
    
    if (isNaN(min)) min = 0;
    if (isNaN(max)) max = 500;

    noUiSlider.create(this.sliderTarget, {
      start: [min, max],
      connect: true,
      range: {
        'min': 0,
        'max': 2000
      }
    });

    this.minPriceTarget.value = min;
    this.maxPriceTarget.value = max;

    // noUiSlider gives handles role="slider" + aria-value* + arrow-key support,
    // but no name. Label each so screen readers can tell them apart (WCAG 4.1.2).
    // The text min/max inputs below are the single-pointer alternative (2.5.7).
    const handleLabels = ['Minimum price', 'Maximum price'];
    const handles = this.sliderTarget.querySelectorAll('.noUi-handle');
    handles.forEach((handle, index) => {
      handle.setAttribute('aria-label', handleLabels[index] || 'Price');
      handle.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none" aria-hidden="true">
          <g filter="url(#filter0_d_562_8445)">
            <circle cx="23" cy="22.5" r="10" fill="none" stroke="#020D19" stroke-width="2"/>
            <circle cx="23" cy="22.5" r="8" fill="#020D19"/>
            <circle cx="23" cy="22.5" r="6.5" stroke="#FFFEFD" stroke-width="3"/>
          </g>
          <defs>
            <filter id="filter0_d_562_8445" x="0" y="0.5" width="48" height="48" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dx="1" dy="2"/>
              <feGaussianBlur stdDeviation="8"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0.00784314 0 0 0 0 0.0509804 0 0 0 0 0.0980392 0 0 0 0.1 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_562_8445"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_562_8445" result="shape"/>
            </filter>
          </defs>
        </svg>
      `;
    });

    this.sliderTarget.noUiSlider.on('update', (values, handle) => {
      if (handle === 0) {
        this.minPriceTarget.value = Math.round(values[0]);
        // Restore name attribute when user interacts with slider
        if (!this.minPriceTarget.hasAttribute('name')) {
          this.minPriceTarget.setAttribute('name', 'min_price');
        }
      } else {
        this.maxPriceTarget.value = Math.round(values[1]);
        // Restore name attribute when user interacts with slider
        if (!this.maxPriceTarget.hasAttribute('name')) {
          this.maxPriceTarget.setAttribute('name', 'max_price');
        }
      }
    });

    this.minPriceTarget.addEventListener('change', this.updateSliderFromInput.bind(this));
    this.maxPriceTarget.addEventListener('change', this.updateSliderFromInput.bind(this));
  }
  
    updateSliderFromInput() {
      const minValue = parseInt(this.minPriceTarget.value, 10) || 0;
      const maxValue = parseInt(this.maxPriceTarget.value, 10) || 2000;
      this.sliderTarget.noUiSlider.set([minValue, maxValue]);
      
      // Restore name attributes when user types in inputs
      if (!this.minPriceTarget.hasAttribute('name')) {
        this.minPriceTarget.setAttribute('name', 'min_price');
      }
      if (!this.maxPriceTarget.hasAttribute('name')) {
        this.maxPriceTarget.setAttribute('name', 'max_price');
      }
    }
  }
